<div #benefitsFullscreen class="h-screen w-screen bg-black/70 backdrop-blur-lg overflow-hidden opacity-0 transition-opacity px-4 py-8">

    <!-- INNER CONTAINER -->
    <div>
        
        <!-- HEADER -->
        <div class="flex items-center mb-8 xl:mb-12">

            <div class="grow">
                <h3 class="text-white text-xl font-bold text-center">
                    {{title}}                    
                </h3>
            </div>
            <div>
                
                <app-button
                    (event)="toggleContainer(false)"
                    [custom]="['bg-semiblack hover:bg-white size-10 flex items-center justify-center p-0']"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>

                </app-button>
                
            </div>

        </div>

        <!-- CAROUSEL -->
            <div class="flex flex-col items-center justify-center gap-y-6 lg:w-[1000px] mx-auto">
                
                <div class="carousel  flex items-center justify-center">
        
                    <div class="splide" #carousel>
                        <div class="splide__track">
                            <ul class="splide__list">
                                @for (image of images; track $index) {
                                    <li class="splide__slide">
                                        <img [src]="image" [alt]="'Slide image'" class="carousel-image max-h-[600px] rounded-2xl mx-auto">
                                    </li>
                                }
                            </ul>
                        </div>
                    </div>
            
                </div>
    
                <div [class]="total === 1 ? 'justify-center' : 'justify-between'" class="flex px-2 w-full text-white text-sm">
                    
                    @if(splide){
                        <p class="max-w-[412px]" [innerHTML]="text"></p>
                    }
                    
                    @if (total !== 1) {
                        <p>
                            {{index}} / {{total}}
                        </p>
                    }
    
                </div>
    
            </div>
            
        

    </div>
   
</div>